module.exports = __webpack_public_path__ + "img/logic.46311ff4.png";